document.addEventListener('DOMContentLoaded', ()=>{
  const videoWrapper = document.querySelector('.cdv_side_img_text_without_heading, .giveaway_featured_product');
  const scrollingBar = document.querySelector('.ListScrollingBarWp');
  const announcementBar = document.querySelector('#shopify-section-announcement-bar');

  function handleScroll() {
    const scrollPosition = window.scrollY;
    if (videoWrapper) {
      const showBuyBarPosition = videoWrapper.offsetTop;
      if (scrollPosition > showBuyBarPosition) {
        scrollingBar.classList.add('active');
        document.body.classList.add('HiddenHeaderBar');
      } else {
        scrollingBar.classList.remove('active');
        document.body.classList.remove('HiddenHeaderBar');
      }
    }
    const announcementBarHeight = announcementBar.offsetHeight;
    scrollingBar.style.top = `${announcementBarHeight}px`;
  }
  window.addEventListener('scroll', handleScroll);

  let ScrollTargetPDP = document.querySelectorAll(".ScrollerPdpAtc");
  ScrollTargetPDP.forEach((evt)=>{
    evt.addEventListener('click', (target)=>{
      target.preventDefault();
      if(window.innerWidth > 769){
        var targetElement = document.querySelector('.giveaway_featured_product');
        window.scrollTo({
          top: targetElement.offsetTop - 46,
          behavior: 'smooth'
        });
      }else{
        window.scrollTo({
          top: document.querySelector('.giveaway_featured_product').offsetTop + document.querySelector('.product__media-main_image_mobile').clientHeight,
          behavior: 'smooth'
        });
      }    
    })
  });

 function isInViewportStickyElement(elem) { 
    var bounding = elem.getBoundingClientRect();
    var myElementHeight = elem.offsetHeight;
    var myElementWidth = elem.offsetWidth;
    return (bounding.top >= -myElementHeight && bounding.left >= -myElementWidth && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + myElementWidth && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + myElementHeight) ; 
  };
  
  var recommendationElementTest = document.querySelectorAll('.cdv_quantity_add_to_cart_wrapper');
  window.addEventListener('scroll', ()=>{
    recommendationElementTest.forEach( (evt)=>{
      if ( isInViewportStickyElement(evt) ) {
        document.querySelectorAll(".withoutabteststk").forEach((target)=>{
          target.classList.add('hidden');
        });
      }else{
        document.querySelectorAll(".withoutabteststk").forEach((target)=>{
          target.classList.remove('hidden');
        });
      }
    })
  })  

  let ScrollTargetPDPDrew = document.querySelectorAll(".scrollTargetWay");
  ScrollTargetPDPDrew.forEach((evt)=>{
    evt.addEventListener('click', (target)=>{
      target.preventDefault();
      if(window.innerWidth > 769){
        var targetElement = document.querySelector('.giveaway_featured_product');
        window.scrollTo({
          top: targetElement.offsetTop - 46,
          behavior: 'smooth'
        });
      }else{
        window.scrollTo({
          top: document.querySelector('.giveaway_featured_product').offsetTop + document.querySelector('.product__media-main_image_mobile').clientHeight,
          behavior: 'smooth'
        });
      }    
    })
  });    

});